export const endpoints = {
  auth: {
    login: '/auth/login',
    register: '/auth/register',
    activate: '/auth/activate',
    forgotpassowrd: '/auth/forgotpassword',
    resetpassword: '/auth/resetpassword',
    refresh: '/auth/token/refresh',
  },
  file: {
    info: '/api/file/info',
    download: '/api/file/download',
    uploadImage:  '/api/file/uploadimage',
  },  
  user: {
    list: '/api/user/list',
    add: '/api/user/info/add',
    addCheck: '/api/user/info/add/check',
    update: '/api/user/info/save',
    resetpassword: '/api/user/passwrod/reset',
    downloadexcel: '/api/user/downloadExcel',
  },
  refcode: {
    list: '/api/refcode/list',
    add: '/api/refcode/add',
    update: '/api/refcode/save',
    sort: '/api/refcode/sort',
    bizlist: '/api/refcode/biz/list',
    bizadd: '/api/refcode/biz/add',
    bizupdate: '/api/refcode/biz/save',
    bizsort: '/api/refcode/biz/sort',    
    biztree: '/api/refcode/biz/tree',
    pmlist: '/api/refcode/pmlist',
    cmlist: '/api/refcode/cmlist',
    oplist: '/api/refcode/oplist',
    lecture: {
      codelist: '/api/refcode/lecture/codelist',
      cate : {
        list: '/api/refcode/lecture/cate/list',
        add: '/api/refcode/lecture/cate/add',
        update: '/api/refcode/lecture/cate/save',  
      },
      group : {
        list: '/api/refcode/lecture/group/list',
        add: '/api/refcode/lecture/group/add',
        update: '/api/refcode/lecture/group/save',
        delete: '/api/refcode/lecture/group/delete',  
      }
    },
    mail: {
      codelist: '/api/refcode/mail/codelist',
      codelistN: '/api/refcode/email/codelist',
    } 
  },
  lecturer: {
    list: '/api/lecturer/list',
    history: '/api/lecturer/history',
    info: '/api/lecturer/info',
    add: '/api/lecturer/info/add',
    update: '/api/lecturer/info/save',
    activate: '/api/lecturer/info/activate',
    filesave: '/api/lecturer/file/save',
    delete: '/api/lecturer/info/del',
    downloadexcel: '/api/lecturer/downloadExcel',
    codelist: '/api/lecturer/codelist',
    gtokensave: '/api/lecturer/gtoken/save',
  },
  company: {
    code: '/api/company/code',
    list: '/api/company/list',
    info: '/api/company/info',
    add: '/api/company/info/add',
    match_add: '/api/company/match/add',
    update: '/api/company/info/save',
    delete: '/api/company/info/del',
    filesave: '/api/company/file/save',
    business_update: '/api/company/info/business/save',
    downloadexcel: '/api/company/downloadExcel',
    money: {
      list: '/api/company/money/list',
      add: '/api/company/money/add',
      update: '/api/company/money/update',      
      downloadexcel: '/api/company/money/downloadExcel',
    },
    point: {
      list: '/api/company/point/list',
      add: '/api/company/point/add',
      update: '/api/company/point/update',
      downloadexcel: '/api/company/point/downloadExcel',
    },
  },    
  crm: {
    code: '/api/crm/code',
    list: '/api/crm/list',
    info: '/api/crm/info',
    add: '/api/crm/info/add',
    update: '/api/crm/info/save',
    delete: '/api/crm/info/del',
    app_check: '/api/crm/app/check',
    downloadexcel: '/api/crm/downloadExcel',
  },  
  mailing: {
    list: '/api/mailing/list',
    add: '/api/mailing/info/add',
    downloadexcel: '/api/mailing/downloadExcel',
  },
  mailtemplate: {
    list: '/api/mail/template/list',
    info: '/api/mail/template/info',
    add: '/api/mail/template/add',
    update: '/api/mail/template/save',
    delete: '/api/mail/template/delete',
  },  
  emailtemplate: {
    list: '/api/email/template/list',
    info: '/api/email/template/info',
    add: '/api/email/template/add',
    update: '/api/email/template/save',
    delete: '/api/email/template/delete',
  },  
  smstemplate: {
    list: '/api/sms/template/list',
    info: '/api/sms/template/info',
    add: '/api/sms/template/add',
    update: '/api/sms/template/save',
    delete: '/api/sms/template/delete',
  },    
  project: {
    list: '/api/project/list',
    listexcel: '/api/project/list/excel',
    info: '/api/project/info',
    add: '/api/project/info/add',
    addfromask: '/api/project/info/add/fromask',
    update: '/api/project/info/save',    
    delete: '/api/project/info/delete',
    next_project:  '/api/project/next/list',
    schedule: {
      list: '/api/project/schedule/list',
      info: '/api/project/schedule/info',
      add: '/api/project/schedule/info/add',
      update: '/api/project/schedule/info/save',    
      delete: '/api/project/schedule/info/delete',
      check: '/api/project/schedule/check',   
      checkd: '/api/project/schedule/checkd',  
      ono: {
        mailsend: '/api/project/schedule/ono/email/send',
        email: '/api/project/schedule/ono/email',        
      }, 
      standby: {
        info: '/api/project/schedule/standby',
        add: '/api/project/schedule/standby/add',
        update: '/api/project/schedule/standby/save',    
        delete: '/api/project/schedule/standby/delete',
        projectList: '/api/project/schedule/standby/projectList',
      }
    },  
    memo : {
      list: '/api/project/memo/list',
      info: '/api/project/memo/info',
      add: '/api/project/memo/add',
      update: '/api/project/memo/save',
    },  
    operator: {
      info: '/api/project/operator/info',
      save: '/api/project/operator/save',
      delete: '/api/project/operator/delete',
    }, 
    consult: {
      list: '/api/project/consult/list',
    },
    drop: {
      list: '/api/project/drop/list',
    },    
    ask: {
      list: '/api/project/ask/list',
      excel: '/api/project/ask/list/excel',
      info: '/api/project/ask/info',
      add: '/api/project/ask/info/add',
      update: '/api/project/ask/info/save',  
      delete: '/api/project/ask/info/del',
      updatecheck: '/api/project/ask/info/save/check',  
      note : {
        info: '/api/project/ask/note/info',
        add: '/api/project/ask/note/add',
        update: '/api/project/ask/note/save',
        filesave: '/api/project/ask/note/file/save',
      },         
    },
    diagnose: {
      info: '/api/project/diagnose/info',
      add: '/api/project/diagnose/info/add',
      update: '/api/project/diagnose/info/save',    
      delete: '/api/project/diagnose/info/delete',
      copy:  '/api/project/diagnose/info/copy',      
    },    
  },
  b2c: {
    info: '/api/b2c/info',    
    add: '/api/b2c/info/add',
    update: '/api/b2c/info/save',    
    update_memo: '/api/b2c/info/save/memo',    
    close: '/api/b2c/info/close',    
    delete: '/api/b2c/info/delete',    
    drop: '/api/b2c/info/drop',
    copy: '/api/b2c/info/copy',    
    next_lecture:  '/api/b2c/next/lecture/list',
    daily_list:  '/api/b2c/group/daily/list',    
    list: {
      ing: '/api/b2c/list/ing',
      close: '/api/b2c/list/close',
      excel: '/api/b2c/list/excel',
    },
    pml: {
      info: '/api/b2c/pml/info', 
      add: '/api/b2c/pml/info/add',
      update: '/api/b2c/pml/info/save',
      list: {
        ing: '/api/b2c/pml/list/ing',
        close: '/api/b2c/pml/list/close',
        excel: '/api/b2c/pml/list/excel',
      },      
    },
    seminar: {
      list: '/api/b2c/seminar/list',
      listexcel: '/api/b2c/seminar/list/excel',
      info: '/api/b2c/seminar/info', 
      add: '/api/b2c/seminar/info/add',
      update: '/api/b2c/seminar/info/save',  
      student: {
        list: '/api/b2c/seminar/student/list',
        add: '/api/b2c/seminar/student/add',
        update: '/api/b2c/seminar/student/save',
        delete: '/api/b2c/seminar/student/delete',
        upload: '/api/b2c/seminar/student/upload',
        downloadexcel: '/api/b2c/seminar/student/downloadExcel',
        downloadexcel2: '/api/b2c/seminar/student/downloadExcel2',
      },          
    },
    operator: {
      info: '/api/b2c/operator/info',
      save: '/api/b2c/operator/save',
      delete: '/api/b2c/operator/delete',
    }, 
    schedule: {
      list: '/api/b2c/schedule/list',
      info: '/api/b2c/schedule/info',
      add: '/api/b2c/schedule/info/add',
      update: '/api/b2c/schedule/info/save',    
      delete: '/api/b2c/schedule/info/delete',
      check: '/api/b2c/schedule/check',   
      checkd: '/api/b2c/schedule/checkd',   
    }, 
    student: {
      list: '/api/b2c/student/list',
      non_attend_list: '/api/b2c/student/noattend/list',
      info: '/api/b2c/student/info',
      add: '/api/b2c/student/add',
      update: '/api/b2c/student/save',
      delete: '/api/b2c/student/delete',
      putoff: '/api/b2c/student/putoff',
      reinforce: '/api/b2c/student/reinforce',
      penalty: '/api/b2c/student/penalty',
      attend: '/api/b2c/student/attend',
      restore: '/api/b2c/student/restore',
      upload: '/api/b2c/student/upload',
      mail: '/api/b2c/student/mail',
      mailsend: '/api/b2c/student/mail/send',
      mailsendmulti: '/api/b2c/student/mail/send/multi',
      smssendmulti: '/api/b2c/student/sms/send/multi',
      email: '/api/b2c/student/email',
      downloadexcel: '/api/b2c/student/downloadExcel',
      history: '/api/b2c/student/history',
    },   
    quotation: {
      insert: '/api/b2c/quotation/insert ',
    }
  },
  schedule: {
    list: '/api/schedule/list',   
  },
  operate: {
    list: '/api/operate/list',   
  },
  bill: {
    list : '/api/bill/list', 
    info: {
      public: '/api/bill/info/public',  
      request: '/api/bill/info/request',  
      update: '/api/bill/info/save',  
      update_status: '/api/bill/info/save/status',  
      insert_b2b: '/api/bill/b2b/add',  
    },
    b2c: {
      info: {
        public: '/api/bill/b2c/info/public',  
        request: '/api/bill/b2c/info/request',  
        update: '/api/bill/b2c/info/save',  
        update_status: '/api/bill/b2c/info/save/status',  
        insert: '/api/bill/b2c/add',  
      },
    }
  },
  payment: {
    list: '/api/payment/list',  
    info: '/api/payment/info',
    info_request: '/api/payment/info/request',
    info_confirm: '/api/payment/info/confirm',
    info_update: '/api/payment/info/save',
    info_add: '/api/payment/info/add',
  },
  outsourcing: {
    list: '/api/outsourcing/list',
    status: '/api/outsourcing/info/status',
  },  
  mypage: {
    logininfo: '/api/mypage/logininfo',
    b2b1: '/api/mypage/b2b1',
    b2b4: '/api/mypage/b2b4',
    b2b4Excel: '/api/mypage/b2b4/excel',
    b2b5: '/api/mypage/b2b5',
    b2c1: '/api/mypage/b2c1',
    seminar1: '/api/mypage/seminar1',
    pml1: '/api/mypage/pml1',
    op1: '/api/mypage/op1',
    op3: '/api/mypage/op3',
    bill: '/api/mypage/bill',
    billhidden: '/api/mypage/bill/hidden',
    payment: '/api/mypage/payment',
    paymenthidden: '/api/mypage/payment/hidden',
    menu: '/api/mypage/menu',
  },
  management: {
    sales: '/api/management/sales',
    salesDetail: '/api/management/sales/detail',
    close: '/api/management/close',
    closeDetail: '/api/management/close/detail',
    closeUpdate: '/api/management/close/update',
    lecturer: '/api/management/sales/lecturer',
    lecturerDetail: '/api/management/sales/lecturer/detail',
    indicators: {
      year: '/api/management/indicators/year',
      day: '/api/management/indicators/day',
      range: '/api/management/indicators/range',
      top: '/api/management/indicators/top15',
      new: '/api/management/indicators/new',
      type: '/api/management/indicators/type',
      content: '/api/management/indicators/contentNew',
      ask: '/api/management/indicators/ask',
      lecturer: '/api/management/indicators/lecturer',
      subjectTop: '/api/management/indicators/subjectTop',
      val : {
        updateType: '/api/management/indicators/type/val/update',
      } 
    }
  },
  master : {
    setup: {
      rate : {
        list: '/api/master/setup/rate/list',
        save: '/api/master/setup/rate/save',
      }, 
      movie: {
        list: '/api/master/setup/movie/list',
        save: '/api/master/setup/movie/save',
      },       
    },
    sale: {
      lecture: {
        list: '/api/master/sale/lecture/list',
        excel: '/api/master/sale/lecture/list',
        downloadexcel: '/api/master/sale/lecture/downloadExcel',
      }, 
      lecturer: {
        list: '/api/master/sale/lecturer/list',
        excel: '/api/master/sale/lecturer/list',
        downloadexcel: '/api/master/sale/lecturer/downloadExcel',
      }, 
    }
  }
};
